import { Injectable } from '@angular/core';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Observable, of } from 'rxjs';
import { NavigationService } from '../../../core/service/navigation.service';
import { DirectDebit } from '../../model/direct-debit';
import { directDebitCommand } from '../../command/direct-debit';

@Injectable()
export class OpenInvoiceFromDirectDebitCommandHandler implements ICommandHandler {
  constructor(private _navigation: NavigationService) {}

  canExecute(command: Command): boolean {
    if (!command || !command.context) return false;
    return command.id == directDebitCommand.openInvoice;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof Command) {
      this._navigation.navigate(['invoices', 'edit', (<DirectDebit>command.context).invoiceId]);
      return of(true);
    }
  }
}
